// Initial form data structure
export const INITIAL_FORM_DATA = {
    // Step 1: Pack
    packId: "",

    // Step 2: Model
    modelId: "",
    useModel: true,

    // Step 3: Settings
    count: 10, // For auto-generated mode
    customCodesCount: 0, // For custom codes mode (calculated)
    seats: 1,
    users_per_license: 0,
    productId: "",
    validity: 0,
    validityType: "lifetime", // lifetime or days
    activationCodeType: "auto", // auto or explicit
    explicitCodes: "",
    codeGenerationModelId: "", // Model to use for code generation pattern
    codePattern: "XXXX-XXXX",
    codeSet: "A-Z,0-9",
    supportedPlatforms: [], // Array of supported platforms
}

// Steps configuration
export const STEPS = [
    { number: 1, title: "Select License Pack" },
    { number: 2, title: "Configure Generation" },
    { number: 3, title: "Review & Generate" },
]

// Common prop types for step components
export const StepComponentPropTypes = {
    formData: "object",
    errors: "object",
    onInputChange: "function",
    onNext: "function",
    onPrevious: "function",
}